import type { AspectRatio, Rect, Size } from '@/core/geometry/types'

export function assertPositiveSize(size: Size, label: string): void {
  if (!Number.isFinite(size.width) || !Number.isFinite(size.height) || size.width <= 0 || size.height <= 0) {
    throw new Error(`${label} must have finite, positive dimensions`)
  }
}

export function assertIntegerRectInsideBounds(rect: Rect, bounds: Size, label: string): void {
  if (![rect.x, rect.y, rect.width, rect.height].every(Number.isInteger)) {
    throw new Error(`${label} must use integer source-pixel coordinates`)
  }
  if (rect.width <= 0 || rect.height <= 0) {
    throw new Error(`${label} dimensions must be positive`)
  }
  if (rect.x < 0 || rect.y < 0
    || rect.x + rect.width > bounds.width
    || rect.y + rect.height > bounds.height) {
    throw new Error(`${label} must stay inside the source image`)
  }
}

export function assertRectMatchesRatio(
  rect: Rect,
  ratio: AspectRatio,
  label: string,
  ratioLabel: string,
): void {
  if (!Number.isFinite(ratio.w) || !Number.isFinite(ratio.h) || ratio.w <= 0 || ratio.h <= 0) {
    throw new Error(`${label} ratio must have finite, positive sides`)
  }
  const expectedHeight = rect.width * (ratio.h / ratio.w)
  if (Math.abs(expectedHeight - rect.height) > 1) {
    throw new Error(`${label} does not match the effective ${ratioLabel} ratio`)
  }
}
